var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsGithub = function SvgMillustrationsGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "M28 13a7 7 0 0 0-2.215 13.64c.35.065.5-.15.5-.335v-1.19c-1.945.42-2.355-.94-2.355-.94a1.86 1.86 0 0 0-.81-1.025c-.635-.43.05-.425.05-.425.45.063.844.331 1.07.725a1.5 1.5 0 0 0 2.04.58c.028-.355.184-.687.44-.935-1.55-.18-3.185-.78-3.185-3.46a2.7 2.7 0 0 1 .72-1.88 2.5 2.5 0 0 1 .07-1.85s.585-.19 1.925.715a6.65 6.65 0 0 1 3.5 0c1.335-.905 1.92-.715 1.92-.715a2.5 2.5 0 0 1 .07 1.85 2.7 2.7 0 0 1 .72 1.88c0 2.69-1.635 3.28-3.195 3.455.338.343.511.815.475 1.295v1.92c0 .23.125.405.5.335A7 7 0 0 0 28 13",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsGithub;